import LegalPage from "../../components/legal/LegalPage";
import document from "../../content/legal/next-of-kin-policy.json";

export default function Page() {
  return <LegalPage title="Next of Kin Policy" document={document} />;
}
